import React, { useState } from "react";
import styled from 'styled-components';
import EmojiPicker, {
  EmojiStyle,
  SkinTones,
  Theme,
  Categories,
  EmojiClickData,
  Emoji,
  SuggestionMode,
  SkinTonePickerLocation
} from "emoji-picker-react";

import smilePlusIcon from "../../../../../public/img/smile-plus-2.png";

const RemoveEmojiButton = styled.button`
color: var(--gray-medium3, #666);
leading-trim: both;
text-edge: cap;
font-family: Open Sans;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 120%;
letter-spacing: 0.056px;
text-decoration-line: underline;
background-color: transparent;
border: none;
&:hover {
  color: #446372;
  text-decoration-line: none;
}
`;

function EmojiPickerWithDelete({
  handleEmojiSelect,
  handleEmojiDelete,
  selectedEmojis,
  toggleEmojiPicker,
  showEmojiPicker}) {
  return (
    <div>
      {!selectedEmojis &&
      <>
        <div><label>Emoji</label></div>
        <a tabIndex={0} style={{cursor:"pointer"}} aria-label="Emoji Picker" onClick={toggleEmojiPicker}>
          <img src={smilePlusIcon} />
        </a>
      </>
      }
      {showEmojiPicker && (
        <div style={{marginTop:"10px"}}>
          <EmojiPicker
            onEmojiClick={handleEmojiSelect}
            autoFocusSearch={false}
            emojiStyle={EmojiStyle.NATIVE}
            emojiVersion="5.0"
          />
        </div>
      )}
      <div style={{marginTop:"10px"}}>
        {
        //selectedEmojis.map((emoji, index) => (
          selectedEmojis && (
          <div  style={{ display: "inline-block", marginRight: "10px" }}>
            {selectedEmojis}{" "}
            {selectedEmojis.trim() &&
            <RemoveEmojiButton type="button" onClick={() => handleEmojiDelete(selectedEmojis)}>
              Remove Emoji
            </RemoveEmojiButton>
            }
          </div>
        )
      //))
      }
      </div>
    </div>
  );
}

export default EmojiPickerWithDelete;
